













import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
//@ts-ignore
import store from "../../store";
import type {Player} from "../../../types";

@Component({
    components: {},
})

/**
 * Результы внешнего голосования в сите
 */
export default class SeatExternalVotingResults extends Vue {
    @Prop({required: true}) private readonly seat!: Player;
    @Prop({required: true}) private readonly message!: any;

    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Имя игрока по ID
     * @private
     */
    private getPlayerName(id: string): string
    {
        const state = store.getters.getGameState;
        return state.playersData[id].name.toString();
    }

    /**
     * Получить проголосовавших игроков
     * @param text
     * @returns {[]}
     */
    private getVotedPlayers(text: string): any
    {
        let players: any = [];

        if (!this.message.data.optionsGroups.length) {
            return players;
        }

        if (typeof this.message.data.optionsGroups[0] === "undefined") {
            return players;
        }

        this.message.data.optionsGroups[0].options.forEach((option: any) => {
            if (option.text === text) {
                if (!this.message.data.anonymous) {
                    option.votersIds.forEach((id: string) => {
                        const votedPlayers = this.players.filter((player: Player) => {
                            return player.id === id;
                        });
                        if (typeof votedPlayers[0] !== 'undefined') {
                            players.push(votedPlayers[0]);
                        }
                    })
                }
                if (this.message.data.anonymous && option.votesCount) {
                    for (let i = 0; i < option.votesCount; i++) {
                        players.push(1);
                    }
                }
            }
        });

        return players;
    }
}
